import { defineMessages } from 'react-intl';

export default defineMessages({
  dishPS: {
    id: 'dish.PS',
    defaultMessage: '备注',
  },
  dishtoppings: {
    id: 'dish.toppings',
    defaultMessage: '配料',
  },
  dishfillToCut: {
    id: 'dish.fillToCut',
    defaultMessage: '满{full}立减{currency}',
  },
  dishfillToDiscount: {
    id: 'dish.fillToDiscount',
    defaultMessage: '满{full}可享{discount}折',
  },
  dishinTotal: {
    id: 'dish.inTotal',
    defaultMessage: '共{dishesDataDuplicate}份',
  },
  dishtotal: {
    id: 'dish.total',
    defaultMessage: '总计：',
  },
  dishxxPart: {
    id: 'dish.xxPart',
    defaultMessage: '{getDishesCount}份',
  },
  dishremake: {
    id: 'dish.remake',
    defaultMessage: '备注:',
  },
  dishSubmit: {
    id: 'dish.Submit',
    defaultMessage: '提交订单',
  },
  dishstoreIsClosed: {
    id: 'dish.storeIsClosed',
    defaultMessage: '非常抱歉，门店已打烊',
  },
  dishlowestCust: {
    id: 'dish.lowestCust',
    defaultMessage: '本桌最低消费{lowestConsumptionValue}元',
  },
  dishgotoAddOn: {
    id: 'dish.gotoAddOn',
    defaultMessage: '去凑单',
  },
  dishselectEnough: {
    id: 'dish.selectEnough',
    defaultMessage: '请选择足够的子菜份数',
  },
  dishrequired: {
    id: 'dish.required',
    defaultMessage: '必选',
  },
  dishselectName: {
    id: 'dish.selectName',
    defaultMessage: '请选择{name}',
  },
  dishguessYouLike: {
    id: 'dish.guessYouLike',
    defaultMessage: '猜你喜欢',
  },
  unlimited: {
    id: 'dish.unlimited',
    defaultMessage: '不限',
  },
  dishCartDiscounted: {
    id: 'dishCartDiscounted',
    defaultMessage: '折扣已减',
  },
  dishCartCut: {
    id: 'dishCartCut',
    defaultMessage: '已减',
  },
  dishCartCutNow: {
    id: 'dishCartCutNow',
    defaultMessage: '立减{currency}{reduce}',
  },
  dishCartGetDiscount: {
    id: 'dishCartGetDiscount',
    defaultMessage: '可享{discount}折',
  },
  dishCartNoSendPay: {
    id: 'dishCartNoSendPay',
    defaultMessage: '免配送费',
  },
  dishCartCanGet: {
    id: 'dishCartCanGet',
    defaultMessage: '可享',
  },
});



// WEBPACK FOOTER //
// ./src/intl/messages/dish/index.js